import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children"];
import React from 'react';
import { CODE_PREVIEW_PREFIX } from './CodePreview';
import { jsx as _jsx } from "react/jsx-runtime";
export var Preview = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      className,
      children
    } = props,
    htmlProps = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [CODE_PREVIEW_PREFIX + "-preview", className].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("div", _extends({}, htmlProps, {
    className: cls,
    ref: ref,
    children: children
  }));
});
Preview.displayName = 'uiw.Preview';